import * as Sentry from '@sentry/browser'

const handlers = new Map()
const wildcardHandlers = new Set()

export const off = (event, fn) => {
  handlers.get(event)?.delete(fn)
}

export const on = (event, fn) => {
  if (!handlers.has(event)) handlers.set(event, new Set())
  handlers.get(event).add(fn)
  return () => off(event, fn)
}

export const onAny = (fn) => {
  wildcardHandlers.add(fn)
  return () => wildcardHandlers.delete(fn)
}

const runHandler = (fn, args, event) => {
  try {
    fn(...args)
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`localBus listener for "${event}" threw`, e)
    if (window.SENTRY_INITIALIZED) Sentry.captureException(e)
  }
}

export const emit = (event, payload) => {
  handlers.get(event)?.forEach((fn) => runHandler(fn, [payload], event))
  wildcardHandlers.forEach((fn) => runHandler(fn, [event, payload], event))
}

export const clear = () => {
  handlers.clear()
  wildcardHandlers.clear()
}
